<template>
    <div class="c-support-overlay is-active">
        <div class="c-support-wrapper large-text-center">
            <button class="close-button c-overlay-close-button" aria-label="Close alert" type="button" v-on:click.prevent="closeQuoteReveal">
                <span aria-hidden="true">&times;</span>
            </button>
            <div class="c-accordion-overlay is-succes">
                <h2 class="c-heading-large u-color-white u-padding-vertical-medium" :class="{'u-no-margin-bottom' : global_element.text}">{{ translate('frontend.js.quotation.heading_overlay') }}</h2>
                <template v-if="global_element.text">
                    <p class="u-color-white u-margin-bottom-small" v-html="global_element.translated_text"></p>
                </template>
                <div v-if="success" class="u-color-white">{{ success }}</div>
                <button v-if="success" class="button outlined" v-on:click="closeQuoteReveal">{{ translate('frontend.js.quotation.close_overlay') }}</button>
            </div>
            <errors v-if="error_messages" :errors="error_messages"></errors>
            <form class="c-form js-form-animation c-support-form" v-if="!success">
                <ul class="c-accordion js-accordion u-no-margin-bottom">
                    <!-- Step one -->
                    <li class="c-accordion-item" :class="[(step_one_validated && !edit_step_one ? 'is-saved' : ''), (step_one_open ? 'is-active' : '')]">
                        <a href="#" class="c-accordion-title-wrapper" v-on:click.prevent="editStepOne">
                            <div class="c-accordion-title-inner text-left">
                                <span class="c-accordion-title c-heading-tiny">{{ translate('frontend.js.quotation.step_one.heading') }}</span>
                            </div>
                            <div class="c-accordion-title-inner is-edit text-left flex-container align-middle">
                                <span v-if="step_one_open === false && step_one_validated === true">{{ translate('frontend.js.quotation.edit') }}</span>
                                <span v-else-if="step_one_open === false && step_one_validated === false">{{ translate('frontend.js.quotation.open') }}</span>
                            </div>
                        </a>
                        <div v-if="!this.step_one_validated || edit_step_one" class="c-accordion-content">
                            <div class="c-accordion-content-inner-wrapper">
                                <figure class="c-figure-quotation flex-container align-center" v-if="getStorageBoxImage()">
                                    <img class="c-figure" :src="changeImageSize(getStorageBoxImage(), '_', 200)" alt="">
                                </figure>
                                <div class="c-field-group">
                                    <label for="type-of-box" class="c-support-field-label u-color-white text-left u-bold u-margin-bottom-tiny">{{ translate('frontend.js.quotation.step_one.which_box_needed') }} <u><a v-on:click.prevent="openAllBoxesPage" class="u-color-white">{{ translate('frontend.js.global.view_all_boxes') }}</a></u></label>
                                    <select class="c-select quotation" v-bind:class="[(is_placeholder_one ? 'c-select quotation is-change support' : 'c-select quotation support')]" id="type-of-box" @change="handleSelectColorOne" v-model="form.storage_box_id">
                                        <option :value="null" disabled selected>{{ translate('db.js.quotation.type_box') }}</option>
                                        <option v-for="storage_box in storage_boxes" :value="storage_box.id">{{ storage_box.name }} ({{ storage_box.min_size }}-{{ storage_box.max_size }}m³)</option>
                                    </select>
                                    <template v-if="storage_box_selection && storage_box_selection.price && storage_box_selection.price_to">
                                        <span class="u-color-white c-field-message">{{ translate('frontend.js.quotation.storage_box_price', {from: storage_box_selection.price, to: storage_box_selection.price_to }) }}</span>
                                    </template>

                                    <div class="c-field-message is-error u-bold text-left" v-if="hasError('storage_box_id') && step_one_validated === false">
                                        <template v-for="error in getError('storage_box_id')">{{ error }}</template>
                                    </div>
                                </div>
                                <div class="c-field-group">
                                    <label for="quotation-location" class="c-support-field-label u-color-white text-left u-bold u-margin-bottom-tiny">{{ translate('frontend.js.quotation.step_one.which_location') }}</label>
                                    <input type="text" id="quotation-location" :value="establishment.title" class="c-input-text support readonly" readonly>

                                    <div class="c-field-message is-error u-bold text-left" v-if="hasError('establishment_id') && step_one_validated === false">
                                        <template v-for="error in getError('establishment_id')">{{ error }}</template>
                                    </div>
                                </div>
                                <div class="c-field-group">
                                    <label for="start_date_at" class="c-support-field-label u-color-white text-left u-bold u-margin-bottom-tiny">{{ translate('frontend.js.quotation.step_one.start_date_at') }}</label>
                                    <datetimepicker
                                        v-if="is_loading === false"
                                        v-model="form.start_date_at"
                                        :format="'d-m-Y'"
                                        :timepicker="false"
                                        :datepicker="true"
                                        classes="c-input-text support valid"
                                        :min_date="min_date"
                                        :default_date="min_date"
                                        :max_date="max_date"
                                        :placeholder="translate('frontend.js.contact.date_placeholder')"
                                        readonly
                                    ></datetimepicker>
                                    <div class="c-field-message is-error u-bold text-left" v-if="hasError('start_date_at') && step_one_validated === false">
                                        <template v-for="error in getError('start_date_at')">{{ error }}</template>
                                    </div>
                                </div>
                                <div class="flex-container align-right">
                                    <button class="button is-continue" v-on:click.prevent="validateStepOne">{{ translate('frontend.js.quotation.next') }}</button>
                                </div>
                            </div>
                        </div>
                        <div v-if="step_one_validated && !edit_step_one" class="c-accordion-content">
                            <div class="c-accordion-content-inner-wrapper flex-container align-middle">
                                <figure class="c-figure-quotation" v-if="getStorageBoxImage()">
                                    <img class="c-figure" :src="changeImageSize(getStorageBoxImage(), '_', 200)" alt="">
                                </figure>
                                <table class="c-accordion-table u-color-white text-left">
                                    <tr>
                                        <td class="u-bold u-padding-right-small u-top-align">{{ translate('frontend.js.quotation.step_one.box_type') }}</td>
                                        <td class="u-top-align">{{ storage_box_selection.name }} ({{ storage_box_selection.min_size }}-{{ storage_box_selection.max_size }}m³)</td>
                                    </tr>
                                    <tr>
                                        <td colspan="2">{{ translate('frontend.js.quotation.storage_box_price', {from: storage_box_selection.price, to: storage_box_selection.price_to }) }}</td>
                                    </tr>
                                    <tr>
                                        <td class="u-bold u-padding-right-small u-top-align">{{ translate('frontend.js.quotation.step_one.location') }}</td>
                                        <td class="u-top-align">{{ establishment_selection.title }}</td>
                                    </tr>
                                    <tr>
                                        <td class="u-bold u-padding-right-small u-top-align">{{ translate('frontend.js.quotation.step_one.start_date_at') }}</td>
                                        <td class="u-top-align">{{ form.start_date_at }}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </li>
                    <!-- Step two -->
                    <li class="c-accordion-item" :class="[(step_two_validated && !edit_step_two ? 'is-saved' : ''), (step_two_open ? 'is-active' : '')]">
                        <a href="#" class="c-accordion-title-wrapper"  v-on:click.prevent="editStepTwo">
                            <div class="c-accordion-title-inner text-left">
                                <span class="c-accordion-title c-heading-tiny">{{ translate('frontend.js.quotation.step_two.heading') }}</span>
                            </div>
                            <div class="c-accordion-title-inner is-edit text-left flex-container align-middle">
                                <span v-if="step_two_open === false && step_two_validated === true">{{ translate('frontend.js.quotation.edit') }}</span>
                                <span v-else-if="step_two_open === false && step_two_validated === false">{{ translate('frontend.js.quotation.open') }}</span>
                            </div>
                        </a>
                        <div v-if="!step_two_validated || edit_step_two" class="c-accordion-content">
                            <div class="c-accordion-content-inner-wrapper">
                                <div class="c-field-group">
                                    <label for="quotation-first-name" class="c-support-field-label u-color-white text-left u-bold u-margin-bottom-tiny">{{ translate('frontend.js.quotation.step_two.name') }}</label>
                                    <input type="text" id="quotation-first-name" :placeholder="[[ translate('frontend.js.quotation.step_two.placeholder.name') ]]" v-model="form.name" class="c-input-text support">

                                    <div class="c-field-message is-error u-bold text-left" v-if="hasError('name')">
                                        <template v-for="error in getError('name')">{{ error }}</template>
                                    </div>
                                </div>

                                <div class="c-field-group">
                                    <label for="quotation-email" class="c-support-field-label u-color-white text-left u-bold u-margin-bottom-tiny">{{ translate('frontend.js.quotation.step_two.email') }}</label>
                                    <input type="text" id="quotation-email" :placeholder="[[ translate('frontend.js.quotation.step_two.placeholder.email') ]]" class="c-input-text support" v-model="form.email">

                                    <div class="c-field-message is-error u-bold text-left" v-if="hasError('email')">
                                        <template v-for="error in getError('email')">{{ error }}</template>
                                    </div>
                                </div>

                                <div class="c-field-group">
                                    <label for="quotation-phone" class="c-support-field-label u-color-white text-left u-bold u-margin-bottom-tiny">{{ translate('frontend.js.quotation.step_two.phone') }}</label>
                                    <input type="tel" id="quotation-phone" :placeholder="[[ translate('frontend.js.quotation.step_two.placeholder.phone') ]]" class="c-input-text support" v-model="form.phone_number">

                                    <div class="c-field-message is-error u-bold text-left" v-if="hasError('phone_number')">
                                        <template v-for="error in getError('phone_number')">{{ error }}</template>
                                    </div>
                                </div>

                                <div class="c-field-group">
                                    <label for="quotation-message" class="c-support-field-label u-color-white text-left u-bold u-margin-bottom-tiny">{{ translate('frontend.js.quotation.step_two.message') }}</label>
                                    <textarea class="c-text-area support" type="text-area" id="quotation-message" :placeholder="[[ translate('frontend.js.quotation.step_two.placeholder.message') ]]" v-model="form.message"></textarea>

                                    <div class="c-field-message is-error u-bold text-left" v-if="hasError('message')">
                                        <template v-for="error in getError('message')">{{ error }}</template>
                                    </div>
                                </div>
                                <div class="flex-container align-right">
                                    <button class="button is-continue" v-on:click.prevent="validateStepTwo">{{ translate('frontend.js.quotation.next') }}</button>
                                </div>
                            </div>
                        </div>
                        <div v-if="step_two_validated && !edit_step_two" class="c-accordion-content">
                            <div class="c-accordion-content-inner-wrapper flex-container flex-dir-column">
                                <table class="c-accordion-table u-color-white text-left" cellspacing=0>
                                    <tr>
                                        <td class="u-bold u-padding-right-small u-half-width u-top-align">{{ translate('frontend.js.quotation.step_two.name') }}:</td>
                                        <td class="u-top-align">{{ form.name }}</td>
                                    </tr>
                                    <tr>
                                        <td class="u-bold u-padding-right-small u-half-width u-top-align">{{ translate('frontend.js.quotation.step_two.email') }}:</td>
                                        <td class="u-top-align">{{ form.email }}</td>
                                    </tr>
                                    <tr>
                                        <td class="u-bold u-padding-right-small u-half-width u-top-align">{{ translate('frontend.js.quotation.step_two.phone') }}:</td>
                                        <td class="u-top-align">{{ form.phone_number }}</td>
                                    </tr>
                                    <tr v-if="form.message != null">
                                        <td class="u-top-align" colspan="2">{{ form.message }}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </li>
                    <!-- Step three -->
                    <li class="c-accordion-item" :class="[(step_three_validated && !edit_step_three ? 'is-saved' : ''), (step_three_open ? 'is-active' : '')]">
                        <a href="#" class="c-accordion-title-wrapper" v-on:click.prevent="editStepThree">
                            <div class="c-accordion-title-inner text-left">
                                <span class="c-accordion-title c-heading-tiny">{{ translate('frontend.js.quotation.step_three.heading') }}</span>
                            </div>
                            <div class="c-accordion-title-inner is-edit text-left flex-container align-middle">
                                <span v-if="step_three_open === false && step_three_validated === true">{{ translate('frontend.js.quotation.edit') }}</span>
                                <span v-else-if="step_three_open === false && step_three_validated === false">{{ translate('frontend.js.quotation.open') }}</span>
                            </div>
                        </a>
                        <div v-if="!step_three_validated || edit_step_three" class="c-accordion-content">
                            <div class="c-accordion-content-inner-wrapper">
                                <div class="c-field-group text-left">
                                    <span class="u-color-white u-bold">{{ translate('frontend.js.quotation.step_three.appointment_question') }}</span>
                                    <div class="flex-container flex-dir-column">
                                        <div class="c-radio-wrapper text-left">
                                            <input id="quotation-make-appointment-no" type="radio" class="c-radio" name="quotation-make-appointment" value="no" v-model="form.question_guided_tour_answer">
                                            <label for="quotation-make-appointment-no" class="c-radio-label white text-left">{{ translate('frontend.js.quotation.step_three.no') }}</label>
                                        </div>
                                        <div class="c-radio-wrapper text-left">
                                            <input type="radio" id="quotation-make-appointment-yes-location" class="c-radio" name="quotation-make-appointment" value='yes-location' v-model="form.question_guided_tour_answer">
                                            <label for="quotation-make-appointment-yes-location" class="c-radio-label white text-left">{{ translate('frontend.js.quotation.step_three.yes_location') }}</label>
                                        </div>
                                        <!-- RL :: Hided for now for HEB-48 -->
                                        <!--<div class="c-radio-wrapper text-left">
                                            <input id="quotation-make-appointment-yes-video" type="radio" class="c-radio" name="quotation-make-appointment" value="yes-video" v-model="form.question_guided_tour_answer">
                                            <label for="quotation-make-appointment-yes-video" class="c-radio-label white text-left">{{ translate('frontend.js.quotation.step_three.yes_video') }}</label>
                                        </div>-->
                                    </div>
                                    <div class="c-field-message is-error u-bold text-left" v-if="hasError('question_guided_tour_answer')">
                                        <template v-for="error in getError('question_guided_tour_answer')">{{ error }}</template>
                                    </div>
                                </div>
                                <template v-if="form.question_guided_tour_answer == 'yes-location' || form.question_guided_tour_answer == 'yes-video'">
                                    <div class="c-field-group u-margin-bottom-small">
                                        <label for="appointment_at" class="c-support-field-label u-color-white text-left u-bold u-margin-bottom-tiny">{{ translate('frontend.js.quotation.step_three.preference_date') }}</label>
                                        <datetimepicker
                                            v-if="is_loading === false"
                                            v-model="form.appointment_at"
                                            :format="'d-m-Y H:i'"
                                            :timepicker="true"
                                            :datepicker="true"
                                            :is_sunday="datetimepicker.is_sunday"
                                            classes="c-input-text support valid"
                                            :step="30"
                                            :min_date="min_date"
                                            :default_date="min_date"
                                            :max_date="max_date"
                                            :disable_weekends="true"
                                            :time_options="datetimepicker.time_options"
                                            :time_options_sunday="datetimepicker.time_options_sunday"
                                            :placeholder="translate('frontend.js.contact.date_placeholder')"
                                            readonly
                                        ></datetimepicker>

                                        <div class="c-field-message is-error u-bold text-left" v-if="hasError('appointment_at')">
                                            <template v-for="error in getError('appointment_at')">{{ error }}</template>
                                        </div>
                                    </div>
                                </template>
                                <div class="flex-container align-center">
                                    <button class="button is-continue" v-on:click.prevent="validateStepThree">{{ translate('frontend.js.quotation.check_data') }}</button>
                                </div>
                            </div>
                        </div>
                        <div v-if="step_three_validated && !edit_step_three" class="c-accordion-content">
                            <div class="c-accordion-content-inner-wrapper flex-container flex-dir-column">
                                <table class="c-accordion-table u-color-white text-left">
                                    <tr>
                                        <td class="u-bold u-third-width u-padding-right-small u-top-align">{{ translate('frontend.js.quotation.step_three.appointment_question') }}</td>
                                        <td class="u-top-align">
                                            <template v-if="form.question_guided_tour_answer == 'yes-location'">{{ translate('frontend.js.quotation.step_three.yes_location') }}</template>
                                            <template v-if="form.question_guided_tour_answer == 'yes-video'">{{ translate('frontend.js.quotation.step_three.yes_video') }}</template>
                                            <template v-if="form.question_guided_tour_answer == 'no'">{{ translate('frontend.js.global.no') }}</template>
                                        </td>
                                    </tr>
                                    <tr v-if="form.appointment_at != null">
                                        <td class="u-bold u-third-width u-padding-right-small u-top-align">{{ translate('frontend.js.quotation.step_three.preference_date') }}</td>
                                        <td class="u-top-align">{{ form.appointment_at }}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </li>
                    <li v-if="step_one_validated && step_two_validated && step_three_validated && !edit_step_one && !edit_step_two && !edit_step_three">
                        <div class="c-accordion-content">
                            <div class="c-accordion-content-inner-wrapper">
                                <div class="c-checkbox-wrapper u-margin-top-small">
                                    <input class="c-checkbox" type="checkbox" id="quotation-terms" name="terms" v-model="form.is_gdpr">
                                    <label for="quotation-terms" class="c-checkbox-label white text-left" :class="{'error' : hasError('is_gdpr')}" v-html="translate('frontend.js.global.terms_and_conditions', {'terms_url' : '/algemene-voorwaarden', 'privacy_statement_url' : '/privacybeleid' })"></label>

                                    <div class="c-field-message is-error u-bold text-left" v-if="hasError('is_gdpr')">
                                        <template v-for="error in getError('is_gdpr')">{{ error }}</template>
                                    </div>
                                </div>

                                <vue-recaptcha :sitekey="this.sitekey" v-on:verify="onCaptchaVerified" v-on:expired="onCaptchaExpired" class="flex-container align-center u-margin-top-small"></vue-recaptcha>

                                <div class="c-field-message is-error u-bold text-left text-center" v-if="hasError('recaptcha')">
                                    <template v-for="error in getError('recaptcha')">{{ error }}</template>
                                </div>

                                <div class="flex-container align-center">
                                    <button type="submit" class="button is-continue" v-on:click.prevent="submitForm" :disabled="disable_submit">{{ translate('frontend.js.quotation.request') }}</button>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </form>
        </div>
    </div>
</template>
<script>
    import VueRecaptcha from 'vue-recaptcha';
    import Errors from '../components/ui/errors';
    import Success from '../components/ui/success';
    import DateTimePicker from '../components/fields/datetimepicker';

    export default {
        name: 'quote-reveal',
        props: ['storage_box', 'disable_scroll'],
        data() {
            return {
                sitekey: '6Ldbu80UAAAAACsG_VLWVEBmSPDYSMa3M_uYgDKp',
                form: {
                    storage_box_id: null,
                    establishment_id: null,
                    is_rent_van: false,
                    is_moving_service: false
                },
                storage_box_selection: this.storage_box || null,
                establishment_selection: null,
                storage_boxes: [],
                establishment: [],
                error_messages: null,
                errors: {},
                success: null,
                disable_submit: false,
                min_date: null,
                max_date: null,
                step_one_validated: false,
                step_two_validated: false,
                step_three_validated: false,
                edit_step_one: false,
                edit_step_two: false,
                edit_step_three: false,
                current_step: 1,
                step_one_open: true,
                step_two_open: false,
                step_three_open: false,
                is_placeholder_one: true,
                is_placeholder_two: true,
                global_element: {
                    type: 'quotation-request'
                },
                is_loading: true,
                datetimepicker: {
                    time_options: [
                        '09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00',
                        '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30'
                    ],
                    time_options_sunday: [
                        '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00',
                        '16:30'
                    ],
                    is_sunday: false
                }
            }
        },
        watch: {
            /**
             * Watch the storage box id change, trigger the set storage box function
             */
             'form.storage_box_id'(storage_box_id) {
                this.setstorageBox(storage_box_id);
            },

            /**
             * Watch the establishment id change, trigger the set establishment function
             */
             'form.question_guided_tour_answer'(question_guided_tour_answer) {
                this.ChangeAppointmentAt();
            }
        },
        components: {
            'vue-recaptcha' : VueRecaptcha,
            'errors'        : Errors,
            'success'       : Success,
            'datetimepicker': DateTimePicker,
        },
        mounted() {
            this.setDateTimePickerValues();
            this.getFormData();
            if(!this.disable_scroll) {
                this.disableScroll();
            }
        },
        beforeDestroy() {
            if(!this.disable_scroll) {
                this.disableScroll();
            }
        },
        methods: {
            /**
             * Get the form data form the api
             *
             * @author Rick van der Burg <rick@click.nl>
             * @return void
             */
            getFormData() {
                axios.all([
                    axios.get('/api/storage-boxes'),
                    axios.get('/api/establishments'),
                    axios.post('/api/global-element', this.global_element),
                    ]).then(axios.spread(this.setFormData));
            },

            /**
             * Set the form data that is relevant for the form, for example select boxes
             *
             * @author Rick van der Burg <rick@click.nl>
             * @param storage_boxes
             * @param establishments
             * @param global_element
             * @return void
             */
            setFormData(storage_boxes, establishments, global_element) {
                this.storage_boxes      = storage_boxes.data;
                this.establishment      = establishments.data[0];
                this.global_element     = global_element.data;

                // Set establishment
                this.form.establishment_id = this.establishment.id;
                this.establishment_selection = this.establishment;

                this.pickRelevantStorageBox();
            },

            /**
             * Pick a relevant storage box
             *
             * @author Rick van der Burg <rick@click.nl>
             * @return void
             */
            pickRelevantStorageBox() {
                if(this.storage_box) {
                    this.form.storage_box_id = this.storage_box.id;
                }
            },

            /**
             * Change the storage box selection when the user selects another storage box, default is the given storage box via the previous screen
             *
             * @author Rick van der Burg <rick@click.nl>
             * @param  storage_box_id
             * @return void
             */
            setstorageBox(storage_box_id) {
                this.storage_box_selection = this.storage_boxes.find((storage_box) => storage_box.id === storage_box_id);
                this.is_placeholder_one = false;
            },

            /**
             * Change value of appointment at to null if question is answered with no
             *
             * @author Robin van Leeuwen <robin@click.nl>
             * @return void
             */
            ChangeAppointmentAt() {
                // If user selected answer 'no' on question guided tour
                if(this.form.question_guided_tour_answer == 'no') {
                    // Set appointment at to null
                    this.form.appointment_at = null;
                }
            },

            /**
             * Get the belonging storage box image, even if the storage box id changes in the form
             *
             * @author Rick van der Burg <rick@click.nl>
             * @return string|boolean
             */
            getStorageBoxImage() {
                if(this.form.storage_box_id && this.storage_boxes.length > 0) {
                    let storage_boxes = this.storage_boxes.filter((storage_box) => storage_box.id === this.form.storage_box_id);
                    let storage_box = storage_boxes[0];
                    if(storage_box.single_file) {
                        return storage_box.single_file.media_path;
                    }
                }
                return false;
            },

            /**
             * Opens all boxes page in a new tab
             *
             * @author Robin van Leeuwen <robin@click.nl
             * @return void
             */
            openAllBoxesPage() {
                window.open('/alle-boxen', '_blank');
            },

            /**
             * Validate step one: box type and location
             *
             * @author Robin van Leeuwen <robin@click.nl> & Lennart van Welzen <lennart@click.nl>
             * @return void
             */
            validateStepOne() {
                axios.post('/api/quotation/step-one', this.form)
                    .then(this.stepOneSuccessFullyValidated)
                    .catch(this.catchErrors);
            },

            /**
             * After step one is validated
             *
             * @author Robin van Leeuwen <robin@click.nl> & Lennart van Welzen <lennart@click.nl>
             * @return void
             */
            stepOneSuccessFullyValidated() {
                if(this.edit_step_one){
                    this.edit_step_one = false;
                } else {
                    this.current_step = 2;
                    this.step_two_open = true;
                    this.step_two_not_validated_and_closed = false;
                }

                this.step_one_validated = true;
                this.step_one_open = false;

                this.error_fields = ['storage_box_id', 'establishment_id', 'start_date_at'];

                // Clear error messages if the errors object is empty
                this.checkErrors(this.error_fields);
            },

            /**
             * Opens step one again when edit button is clicked
             *
             * @author Lennart van Welzen <lennart@click.nl>
             *
             */
            editStepOne(e) {
                if(e.target.classList.contains('c-accordion-title-wrapper') || e.target.parentElement.classList.contains('c-accordion-title-inner')){
                    //If step one is validated the user can still edits the form
                    if(this.step_one_validated) {
                        this.step_one_open = true;
                        this.edit_step_one = true;
                        this.step_one_validated = false;
                    }
                }
            },

            /**
             * Validate step two: personal data and message
             *
             * @author Robin van Leeuwen <robin@click.nl> & Lennart van Welzen <lennart@click.nl>
             * @return void
             */
            validateStepTwo() {
                axios.post('/api/quotation/step-two', this.form)
                    .then(this.stepTwoSuccessFullyValidated)
                    .catch(this.catchErrors);
            },

            /**
             * After step two is validated
             *
             * @author Robin van Leeuwen <robin@click.nl> & Lennart van Welzen <lennart@click.nl>
             * @return void
             */
            stepTwoSuccessFullyValidated() {
                if(this.edit_step_two){
                    this.edit_step_two = false;
                } else {
                    this.current_step = 3;
                    this.step_three_open = true;
                    this.step_three_not_validated_and_closed = false;
                }

                this.step_two_validated = true;
                this.step_two_open = false;

                this.error_fields = ['name', 'email', 'phone_number', 'message'];

                // Clear error messages if the errors object is empty
                this.checkErrors(this.error_fields);
            },

            /**
             * Opens step two and opens step two again when edit button is clicked
             *
             * @author Lennart van Welzen <lennart@click.nl>
             *
             */
            editStepTwo(e) {
                if(e.target.classList.contains('c-accordion-title-wrapper') || e.target.parentElement.classList.contains('c-accordion-title-inner')){
                    //Opens step two
                    if(!this.step_two_open) {
                        this.step_two_open = true;
                    }
                    //If step two is validated the user can still edits the form
                    if(this.step_two_validated) {
                        this.edit_step_two = true;
                        this.step_two_validated = false;
                    }
                }
            },

            /**
             * Validate step three: appointment info and services
             *
             * @author Robin van Leeuwen <robin@click.nl> & Lennart van Welzen <lennart@click.nl>
             * @return void
             */
            validateStepThree() {
                axios.post('/api/quotation/step-three', this.form)
                    .then(this.stepThreeSuccessFullyValidated)
                    .catch(this.catchErrors);
            },

            /**
             * After step three is validated
             *
             * @author Robin van Leeuwen <robin@click.nl> & Lennart van Welzen <lennart@click.nl>
             * @param  reponse
             * @return void
             */
            stepThreeSuccessFullyValidated(reponse) {
                if(this.edit_step_three){
                    this.edit_step_three = false;
                } else {
                    this.current_step = 4;
                }

                this.step_three_validated = true;
                this.step_three_open = false;

                this.error_fields = ['question_guided_tour_answer', 'appointment_at', 'is_rent_van', 'is_moving_service'];

                // Clear error messages if the errors object is empty
                this.checkErrors(this.error_fields);
            },

            /**
             * Opens step three and opens step three again when edit button is clicked
             *
             * @author Lennart van Welzen <lennart@click.nl>
             * @return void
             */
            editStepThree(e) {
                if(e.target.classList.contains('c-accordion-title-wrapper') || e.target.parentElement.classList.contains('c-accordion-title-inner')){
                    //Opens step three
                    if(!this.step_three_open){
                        this.step_three_open = true;
                    }

                    //If step three is validated the user can still edits the form
                    if(this.step_three_validated) {
                        this.edit_step_three = true;
                        this.step_three_validated = false;
                    }
                }
            },

            /**
             * Submit the form with the form data
             *
             * @author Rick van der Burg <rick@click.nl>
             * @return void
             */
            submitForm() {
                this.disable_submit = true;
                this.error_messages = null;

                if(!this.checkIfRecaptchaVerified()) {
                    return false;
                }

                axios.post('/api/quotation', this.form)
                    .then(this.successFullyPosted)
                    .catch(this.catchErrors);
            },

            /**
             * Set form.recaptcha when Recaptcha is verified
             *
             * @author Robin van Leeuwen <robin@click.nl>
             * @param  response
             */
            onCaptchaVerified(response) {
                this.form.recaptcha = response;
            },

            /**
             * Empty form.recaptcha when Recaptcha is expired
             *
             * @author Robin van Leeuwen <robin@click.nl>
             */
            onCaptchaExpired() {
                this.form.recaptcha = null;
            },

            /**
             * Check if Recaptcha is verified before submitting the form
             *
             * @author Robin van Leeuwen <robin@click.nl>
             * @return void
             */
            checkIfRecaptchaVerified() {
                if (!this.form.recaptcha) {
                    this.error_messages = Lang.get('frontend.js.global.recaptcha_error');
                    // Set recaptcha error
                    this.$set(this.errors, 'recaptcha', [ Lang.get('frontend.js.global.recaptcha_error') ]);
                    this.disable_submit = false;
                    return false; // prevent form from submitting
                }
                return true;
            },

            /**
             * After the from successfully posted
             *
             * @author Rick van der Burg <rick@click.nl>
             * @param response
             * @return void
             */
            successFullyPosted(response) {
                this.success = response.data.message;
                this.disable_submit = false;

                // Check if gtag is set before tracking
                if( window.gtag ) {
                    // Measure Google Analytics Event before redirect to next page
                    gtag('event', 'generate_lead', {
                        'event_category': 'engagement',
                        'event_label': 'Verzenden offerteformulier',
                        'transport_type': 'beacon'
                    });
                }
            },

            /**
             * Catch the errors from the form submit
             *
             * @author Rick van der Burg <rick@click.nl>
             * @param error
             * @return void
             */
            catchErrors(error) {
                this.disable_submit = false;
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.error_messages = Lang.get('frontend.js.global.422_error');
                } else {
                    this.error_messages = Lang.get('frontend.js.global.error');
                }
            },

            /**
             * Check wether the form field has an error
             *
             * @author Rick van der Burg <rick@click.nl>
             * @param string field
             * @return boolean
             */
            hasError(field) {
                return this.errors && this.errors[field] && this.errors[field].length > 0;
            },

            /**
             * Check in this.errors if fields needs to be deleted and clear error messages
             *
             * @author Robin van Leeuwen <robin@click.nl>
             * @return void
             */
            checkErrors(error_fields){
                // Loop through error fields
                for (var i = 0; i < error_fields.length; i++) {
                    // Delete a certain field from this.errors
                    if( this.errors != null && Object.keys( this.errors ).includes( error_fields[i] ) ) {
                        this.$delete(this.errors, error_fields[i]);
                    }
                }

                // Clear error messages when errors is an empty object
                if(this.errors != null && Object.keys(this.errors).length === 0) {
                    this.error_messages = null;
                }
            },

            /**
             * Get the error from the field
             *
             * @author Rick van der Burg <rick@click.nl>
             * @param string field
             * @return string
             */
            getError(field) {
                return this.errors[field][0];
            },

            /**
             * Close the quote reveal by giving an event listener back to the parent
             *
             * @author Rick van der Burg <rick@click.nl>
             * @return void
             */
            closeQuoteReveal() {
                this.$emit('closeQuoteReveal');
                // Only when the quotation has been posted successfully, the event closureQuoteReveal will be triggered
                if(this.success) {
                    this.$emit('closureQuoteReveal');
                }
            },

            /**
             * Disables the scroll for the body when overlay is open
             *
             * @author Yonita van Oudheusden <yonita@click.nl>
             * @return void
             */
            disableScroll() {
                var $body = $('body');
                // Add class that will disable the scroll on the body

                if($body.hasClass('u-disable-scroll')) {
                    $body.removeClass('u-disable-scroll');
                } else {
                    $body.addClass('u-disable-scroll');
                }
            },

            /**
             * Set values for DateTimePicker
             * @author Bas Lokerman <bas@click.nl>
             */
            setDateTimePickerValues() {
                var current_date = new Date();
                current_date.setDate(current_date.getDate());
                var day = current_date.getDate();
                var month = current_date.getMonth() + 1;
                var year = current_date.getFullYear();
                var max_year = current_date.getFullYear() + 1;
                this.min_date = day + '-' + month + '-' + year;
                this.max_date = day + '-' + month + '-' + max_year;

                var current_day = current_date.getDay();

                // Check if it's Sunday today (= 0)
                if( current_day == 0) {
                    this.datetimepicker.is_sunday = true;
                }

                this.is_loading = false;
            },

            /**
             * Load in jquery for accordion
             * @author Lennart van Welzen <lennart@click.nl>
             */
            loadAccordion() {
                this.$nextTick(function() {
                    $('.js-accordion').each(function() {
                        new Foundation.Accordion($(this));
                    });
                });
            },

            /**
             * Change first color to none placeholder
             *
             * @author Lennart van Welzen <lennart@click>
             */
            handleSelectColorOne() {
                this.is_placeholder_one = false;
            },

            /**
             * Change second color to none placeholder
             *
             * @author Lennart van Welzen <lennart@click>
             */
            handleSelectColorTwo() {
                this.is_placeholder_two = false;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/frontend/vue/global/quote-reveal.vue